import { Component, Injectable } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Observable, Subject } from 'rxjs';
import { AnomalieSegnalazioneDialogComponent } from '../components/anomalie-segnalazione-dialog/anomalie-segnalazione-dialog.component';
import { DettaglioCampoComponent } from '../components/dettaglio-campo/dettaglio-campo.component';
import { DettaglioDateComponent } from '../components/dettaglio-date/dettaglio-date.component';
import { GenericDialogContentComponent } from '../components/generic-dialog-content/generic-dialog-content.component';
import { GestioneCampiExportDialogComponent } from '../components/gestione-campi-export-dialog/gestione-campi-export-dialog.component';
import { UploadFileComponent } from '../components/upload-file/upload-file.component';
import { UploadProtocolloRegionaleComponent } from '../components/upload-protocollo-regionale/upload-protocollo-regionale.component';

@Injectable({
  providedIn: 'root'
})
export class DialogService {

  confirmed: boolean;
  inputData: string;

  constructor(public dialog: MatDialog) { }

  //FUNZIONE PER APRIRE UNA MODAL DI CONFERMA GENERICA
  openDialog(title: string, message: string, width?:string, height?:string): Observable<boolean> {
    const dialogRef = this.dialog.open(GenericDialogContentComponent, {
      data: { title: title, message: message },
      width: width ? width:'auto',
      height: height? height:'auto'
    });
    return new Observable<boolean>((observer) => {
      dialogRef.afterClosed().subscribe(result => {
        if (result) {
          this.confirmed = true;
        } else {
          this.confirmed = false;
        }
        observer.next(this.confirmed);
        observer.complete();
      });
    });
  };

 // FUNZIONE PER APRIRE LA MODAL DI AGGIUNTA MOTIVAZIONE PER IL RIFIUTO DI UNA SEGNALAZIONE
 openMotivazioneRifiutoDialog(title: string, message: string, segnalazioneRifiutata: boolean, inputTitle: string): Observable<string> {
  const dialogRef = this.dialog.open(GenericDialogContentComponent, {
    data: { title: title, message: message, rifiutaSegnalazione: segnalazioneRifiutata, inputTitle: inputTitle},
    width: 'auto',
    height: 'auto'
  });
  return dialogRef.afterClosed();
};

 // FUNZIONE PER APRIRE LA MODAL DI ESECUZIONE DI OPERAZIONI MASSIVE
 openOperazioneMassivaDialog(title: string, message: string, operazioneMassiva: boolean, segnalazioneRifiutata: boolean, inputTitle: string): Observable<string> {
  const dialogRef = this.dialog.open(GenericDialogContentComponent, {
    data: { title: title, message: message, operazioneMassiva: operazioneMassiva, rifiutaSegnalazione: segnalazioneRifiutata, inputTitle: inputTitle},
    width: 'auto',
    height: 'auto'
  });
  return dialogRef.afterClosed();
};
  // FUNZIONE PER APRIRE LA MODAL DI DUPLICAZIONE E SCELTA DPGR
  openInputDialog(title: string, message: string, input: boolean, inputTitle: string): Observable<string> {
    const dialogRef = this.dialog.open(GenericDialogContentComponent, {
      data: { title: title, message: message, input: input, inputTitle: inputTitle},
      width: 'auto',
      height: 'auto'
    });
    return dialogRef.afterClosed();
  };

    // FUNZIONE PER APRIRE LA MODAL DI DUPLICAZIONE E SCELTA DPGR
    openCampoDupl(title: string, message: string, duplCamp:boolean,inputTitle:string): Observable<string> {
      const dialogRef = this.dialog.open(GenericDialogContentComponent, {
        data: { title: title, message: message, inputTitle:inputTitle, duplCamp:duplCamp},
        width: 'auto',
        height: 'auto'
      });
      return dialogRef.afterClosed();
    };

      // FUNZIONE PER APRIRE LA MODAL DI DUPLICAZIONE E SCELTA DPGR
      openModalAnomalie(title: string, codiceSegnalazione: number): Observable<string> {
        const dialogRef = this.dialog.open(AnomalieSegnalazioneDialogComponent, {
          data: { title: title, codiceSegnalazione:codiceSegnalazione}
        });
        return dialogRef.afterClosed();
      };

      openDialogSegnalazioni(idEvento: number): Observable<string> {
        const dialogRef = this.dialog.open(DettaglioDateComponent, {
          data: {idEvento: idEvento}
        });
        return dialogRef.afterClosed();
      }

      openDialogUpload(descrizione: string, idEvento: number, idEnte: number, idInvio: number): Observable<string> {
        const dialogRef = this.dialog.open(UploadFileComponent, {
          data: {
            descrizione: descrizione,
            idEvento: idEvento,
            idEnte: idEnte,
            idInvio: idInvio,
          }
        });
        return dialogRef.afterClosed();
      }

      openInviaProtocolloUpload(descrizione: string, idEvento: number, idEnte: number, idInvio: number): Observable<string> {
        const dialogRef = this.dialog.open(UploadProtocolloRegionaleComponent, {
          data: {
            descrizione: descrizione,
            idEvento: idEvento,
            idEnte: idEnte,
            idInvio: idInvio,
          }
        });
        return dialogRef.afterClosed();
      }

      openDialogGestioneCampiExport(idEvento: number) : Observable<any> {
        const dialogRef = this.dialog.open(GestioneCampiExportDialogComponent, {
          data: {idEvento: idEvento}
        });
        return dialogRef.afterClosed();
      }
}
